<template lang="pug">
.form-image.center.inside-padding
  form(@submit.prevent="" autocomplete="off")
    h2.title(v-if="title") {{ title || 'Subir Imagenes'}}
    .form-section
      .input-container
        shInputFile(@change="setFileList" :multiple="multiple")
      .images-files
        .image-file(v-for="(file, index) in fileList")
          .image-file-container
            img.image-file-image(:src="createURL(file)")
          // .image-file-name {{ cutString(file.name) }}
          div
            span {{ file.name }}
            span(:class="{'color-red dark': parseInt(file.size / 1024) > 50}")  ({{ parseInt(file.size / 1024) }} kb)
          .image-file-status.capitalize.color-black(v-if="state[index]" :class="`${state[index]}-file-status`") {{ state[index] }}

    .form-section(v-if="showList && !url")
      .input-container.arrow
        select.select(v-model="dataForm.brand" autocomplete="ño" required)
          option(value="")
          option(v-for="brand in brands" :value="brand") {{ capitalize(brand) }}
        label.label(:class="{ show: dataForm.brand }") Marca

      .input-container(v-if="showList && !url")
        label.label.capitalize Persona
        select.select(v-model="dataForm.subfolder" :required="dataForm.folder === 'products'" required)
          option(v-for="subfolder in subfolders" :value="subfolder") {{ subfolder }}

    shActionButton(v-if="fileList.length" :isForm="true" :action="uploadImage" text="Subir Imágenes" textRunning="Subiendo Imágenes")
</template>

<script>
import gql from '@my/graphql'
import gqlImage from '@/graphql/image'
import shInputFile from '@/components/elements/InputFile'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'FormImage',

  mixins: [mForm, mFilters],

  components: { shInputFile },

  props: {
    brand: String,
    person: String,
    url: String,
    multiple: { type: Boolean, default: true },
    title: { type: String }
  },

  mounted () {
    if (this.brand) this.dataForm.brand = this.brand
    if (this.person) this.dataForm.subfolder = this.person
    if (this.brand && this.person) this.showList = false
  },

  data () {
    return {
      dataForm: {
        folder: 'products',
        subfolder: '',
        brand: ''
      },
      fileList: [],
      state: [],
      showList: true
    }
  },

  methods: {
    async uploadImage () {
      if (this.fileList.length) {
        const query = this.url ? gqlImage.UPLOAD_IMAGE_MEASURE : gqlImage.UPLOAD_IMAGE_PRODUCT

        for (let i = 0; i < this.fileList.length; i++) {
          const file = this.fileList[i]

          this.updateArray(this.state, i, 'subiendo')

          const blob = file.slice(0, file.size, file.type)
          const variables = this.url ? { image: null, url: this.url, size: file.size } : { image: null, folder: this.dataForm.folder, subfolder: this.dataForm.subfolder, brand: this.dataForm.brand, size: file.size }

          const data = await gql.mutateImage(query, variables, true, [], blob, file.name, file.size)

          if (!data || (!data.data.uploadImageProduct && !data.data.uploadImageMeasure)) {
            this.updateArray(this.state, i, 'error')
          } else {
            this.updateArray(this.state, i, 'subido')
            this.$emit('uploaded', file.name)
          }
        }
      }
    },

    updateArray (array, index, value) {
      this.$set(array, index, value)
    },

    setFileList (fileList) {
      const keys = Object.keys(fileList)
      const length = keys ? keys.length : 0

      if (length) this.state = Array(length).fill('pendiente')
      this.fileList = fileList
    },

    createURL (file) {
      return URL.createObjectURL(file)
    }
  },

  computed: {
    folders () {
      return this.$store.state.folders
    },
    subfolders () {
      const persons = this.$store.state.persons

      return persons.map(({ person }) => person)
    },
    brands () {
      return this.$store.state.variables.brands
    }
  }
}
</script>

<style lang="stylus">
.form-image
  position relative
  padding-bottom 2em

.images-files
  display grid
  flex-wrap wrap
  column-gap 1em
  grid-template-columns repeat(4, minmax(0, 1fr))
  align-items end
  margin-top 1em

.image-file
  text-align center
  margin-bottom 1.5em

.image-file-container
  min-height 10em
  overflow hidden
  border-radius 1em
  display flex
  width 100%
  flex-wrap wrap

.image-file-image
  width 100%
  align-self center

.image-file-name
  margin-top .3em

.image-file-status
  border-radius 1em
  display inline-block
  padding .1em .7em
  margin-top .6em

.pendiente-file-status
  background-color #c8c8c8

.subiendo-file-status
  background-color #40BEFF

.subido-file-status
  background-color #2DB398

.error-file-status
  background-color #FF5968

.title-min
  font-size 1.2em
</style>



// WEBPACK FOOTER //
// src/components/pages/image/FormUpload.vue